<template>
    <div class="community-list-section">
        <!-- 8公益救助 -->
        <van-row
            class="community-list-section-box"
            @click="goDetail(dataItem)"
        >
            <div class="community-list-section-left">
                <van-image
                    fit="cover"
                    class="community-list-section-left-img"
                    :src="dataItem.content.cover_img"
                    width="100%"
                    height="100%"
                />
                <div class="community-list-section-left-top" v-if="dataItem.top == 1">
                    <img src="/static/bytx/tag_top.svg" alt="" />
                </div>
                <div v-else class="community-list-section-left-zl">
                    {{ dataItem.type_text }}
                </div>
            </div>
            <div class="community-list-section-right">
                <div class="community-list-section-right-title">{{ dataItem.content.title }}</div>
                <div class="community-list-section-info">
                    {{ dataItem.content.desc ? dataItem.content.desc : '为爱点亮希望' }}
                </div>
                <div class="community-list-section-right-detail">
                    <div>
                        <img src="/static/bytx/public/welfare_help_icon_2.svg" />
                        <span @click.stop="applyHelp(dataItem)">申请救助</span>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </van-row>

        <!--申请救助 -->
        <van-dialog class="apply_form" v-model="applyFormDialog" :showConfirmButton="false">
            <template slot="title">
                <div class="close-pop" @click="closeApplyForm">
                    <img src="/static/bytx/popup_close_icon.svg" alt="">
                </div>
                <h3 v-if="!dataItem.content.isApply">申请公益救助</h3>
                <h3 v-else>您已申请，无需重复提交！</h3>
            </template>
            <div class="clear"></div>
            <div v-if="!dataItem.content.isApply">为核实申请信息，为您申请公益救助项目，需您完善真实信息。</div>
            <div v-else style="text-align: center">请将项目名发给小助手，获取报名表或链接</div>
            <div v-if="!dataItem.content.isApply" align="center" style="margin-top: 12px;color: #9D9D9D">
                <van-button class="clinic-detail-footer-right-btn" type="danger" round size="large" @click="goLogin()" color="#0FB7AD">
                    立即填写
                </van-button>
            </div>
            <div v-else style="text-align: center">
                <img width="220" src="/static/qrcode/gyjz.png" alt="">
                <div>长按识别添加</div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import Interface from '@/util/interface.js'
export default {
    props: {
        dataItem: {
            type: Object,
            required: true
        },
        contentType: {
          type: Number,
          default: 0
        },
        searchText: {
          type: String,
          default: ''
        }
    },
    data() {
        return {
            applyFormDialog: false,
            detail: {},
            formData: {
                name: '',
                mobile: '',
                sex: '男',
                identity_name: '患者本人',
                identity: 1
            },
            id: 0
        }
    },
    methods: {
        goLogin() {
            let user = localStorage.getItem('user')
            user = JSON.parse(user)
            sessionStorage.setItem('back-url', this.$route.path)
            sessionStorage.setItem(
                'apply',
                JSON.stringify({
                    apply: 'community',
                    apply_id: this.id
                })
            )
            if(!user || user.mobile == ""){
                this.$router.push({name: 'login'})
            }else{
                this.$router.push({name: 'add-info'})
            }
        },
        changeIdentity() {
            this.$forceUpdate()
        },
        checkPhone(tel) {
            return /^1[3456789]\d{9}$/.test(tel)
        },
        apply() {
            this.id = item.content.id
            if (!this.checkPhone(this.formData.mobile)) {
                this.$toast.fail('手机号格式不正确')
                return
            }
            switch (this.formData.identity_name) {
                case '患者本人':
                    this.formData.identity = 1
                    break
                case '患者家属':
                    this.formData.identity = 2
                    break
                case '医务工作者':
                    this.formData.identity = 3
                    break
                default:
                    this.formData.identity = 4
                    break
            }

            let params = {
                ...this.formData
            }
            Interface.getData('get', Interface.user.apply_community + this.id, params).then(res => {
                if (res.code == 0) {
                    this.openFeedback = true
                    this.applyFormDialog = false
                }
            })
        },
        closeApplyForm() {
            this.applyFormDialog = false
        },
        // 申请救助
        applyHelp(item) {
          this.$router.push({ name: 'community-detail-new', params: { id: item.content.id } })
          Interface.getData('get', `/course-phase/api/recommend_v2/${item.id}/view`)
            // this.id = item.content.id
            // Interface.getData('get', Interface.community.detail + item.content.id).then(res => {
            //     if (res.code == 0) {
            //         this.detail = res.data
            //         this.applyFormDialog = true
            //     }
            // })
        },
      goDetail(dataItem) {
        this.$router.push({ name: 'community-detail-new', params: { id: dataItem.content.id } })
        Interface.getData('get', `/course-phase/api/recommend_v2/${dataItem.id}/view`)
        Interface.mFootPrint(dataItem.id,67,this.contentType,1,0,0,0,dataItem.content.title, this.searchText)
      }
    }
}
</script>

<style lang="scss" scoped>
.community-list-section {
    border-bottom: 1px solid #f2f2f2;
    padding: 10px 12px;
    background-color: #ffffff;
    margin: 10px 10px;
    border-radius: 10px;

    .community-list-section-top {
        border-radius: 6px;
        position: relative;

        .top-tag {
            top: 0;
            left: 0;
            position: absolute;
        }

        .community-list-section-title-box {
            .community-list-section-title {
                font-family: PingFangSC-Semibold;
                font-size: 16px;
                color: #ffffff;
                letter-spacing: 0;
                margin: 3px 15px;
            }

            .community-list-section-info {
                font-family: Helvetica;
                font-size: 13px;
                color: #ffffff;
                letter-spacing: 0;
                margin-left: 15px;
                float: left;
                margin-bottom: 12px;
                margin-top: 12px;
            }

            .community-list-section-icon {
                float: right;
                margin-right: 15px;
                margin-bottom: 12px;
            }

            box-sizing: border-box;
            position: absolute;
            bottom: 0px;
            width: 100%;
            background-image: linear-gradient(180deg, rgba(51, 51, 51, 0) 0%, rgba(0, 0, 0, 0.4) 99%);
            border-radius: 0 0 6px 6px;
        }

        .community-list-section-desc {
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            color: #ffffff;
            letter-spacing: 0.5px;
            line-height: 24px;
            position: absolute;
            padding: 0 6px;
            bottom: 0px;
            left: 15px;
            font-weight: 500;
            margin-bottom: 10px;
            .light {
                color: #0fb7ad;
            }
        }

        .community-list-section-box {
            padding: 0;
            height: 188px;
            width: 100%;
        }
    }

    &-box {
        width: 345px;
        // padding: 18px 0;
        // border-bottom: 1px solid #f2f2f2;
    }

    &-left {
        width: 130px;
        height: 73px;
        float: left;
        position: relative;
        border-radius: 6px;
        &-img {
            width: 112px;
            height: 66px;
            //background: #EFF3FA;
            border-radius: 6px;
            >>> .van-image__img,
            img {
                border-radius: 6px;
            }
        }
        &-zl {
            position: absolute;
            top: 0;
            left: 0;
            background: #10c3b5;
            border-radius: 6px 3px 3px 3px;
            font-family: PingFangSC-Medium;
            font-size: 10px;
            color: #ffffff;
            letter-spacing: 0;
            padding: 1px 6px;
            &.active {
                background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
                border-radius: 6px 3px 3px 3px;
            }
            img {
                width: 32px;
                height: 18px;
            }
        }
    }

    &-right {
        float: left;
        margin-left: 14px;
        width: 193px;
        text-align: left;

        &-time {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #0fb7ad;
            letter-spacing: 0;

            background: #e6fdf6;
            border-radius: 4px;
            display: inline-block;
            padding: 2px 6px;
        }

        &-title {
            font-family: PingFangSC-Medium;
            font-size: 15px;
            color: #222222;
            letter-spacing: 0;
            font-weight: 500;
            .light {
                color: #0fb7ad;
            }
        }

        &-detail {
            margin-top: 14px;
            width: 100%;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #0CC4B9;
            div {
              display: flex;
              flex-direction: row;
              align-items: center;
              span{
                margin-left: 3px;
              }
            }
        }

        .community-list-section-info {
            margin-top: 8px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #9a9a9a;
            letter-spacing: 0;
        }
    }

    .community-list-section {
        padding-bottom: 0px;
        .community-list-section-box {
            border-bottom-width: 0px;
            padding-bottom: 0px;
            .community-list-section-left-img {
                width: 130px;
                height: 73px;
            }
            .community-list-section-left-top {
                position: absolute;
                top: 4px;
                left: 4px;
                width: 18px;
                height: 18px;
                border-radius: 3px;
                img {
                    width: 18px;
                    height: 18px;
                    border-radius: 3px;
                }
            }
            .community-list-section-right-detail {
                span {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #9d9d9d;
                    line-height: 17px;
                }
            }
        }
    }

    .community-list-section-left-zl {
        position: absolute;
        top: 4px;
        left: 4px;
        background: linear-gradient(90deg, rgba(87, 80, 94, 0.9) 0%, rgba(43, 41, 45, 0.9) 100%);
        background: linear-gradient(90deg, #faedd4 0%, #f0dbb6 100%);
        border-radius: 4px;
        font-size: 11px;
        font-family: HarmonyOS_Sans_SC_Bold;
        color: #976730;
        line-height: 16px;
        padding: 1px 1.6vw;
    }
    .community-list-section-left-top {
        position: absolute;
        top: 4px;
        left: 4px;
        width: 18px;
        height: 18px;
        border-radius: 3px;
        img {
            width: 18px;
            height: 18px;
            border-radius: 3px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/contentSelection/modules/community.vue